export default __webpack_public_path__ + "static/media/nigel.1576bcd7.svg";